import { cn } from "@/utils/cn";
import LoadingIconRight from "./loading-icon";
import { Check, Globe, FileText, Wrench } from "lucide-react";

const TOOL_ICONS: Record<string, any> = {
  web_search: Globe,
  document: FileText,
};

export const StepItem = ({
  stepTitle,
  stepNumber,
  status,
  tools,
}: {
  stepTitle: string;
  stepNumber: number;
  status?: "pending" | "running" | "completed";
  tools?: string[];
}) => {
  return (
    <div
      className={cn(
        "min-h-[48px] p-2 sm:p-3 rounded-lg w-full gap-2 sm:gap-3 text-foreground relative overflow-hidden flex flex-wrap sm:flex-nowrap items-center transition-colors",
        {
          "bg-primary/5": status === "running",
        },
      )}
    >
      {status === "running" && (
        <>
          <div className="absolute [inset-inline-start:0rem] bg-[var(--card-background)] blur-[50px] w-[100px] h-[245px] animate-slide motion-reduce:animate-none"></div>
          <LoadingIconRight />
        </>
      )}
      <span
        className={cn(
          "w-5 h-5 rounded-full flex items-center justify-center text-[11px] font-semibold shrink-0",
          {
            "bg-primary/15 text-primary": status === "running",
            "bg-primary text-primary-foreground": status === "completed",
            "bg-muted text-muted-foreground": status === "pending" || !status,
          },
        )}
      >
        {status === "completed" ? (
          <Check size={12} strokeWidth={2.5} />
        ) : (
          stepNumber
        )}
      </span>
      <span
        className={cn("flex-1 truncate text-sm", {
          "text-muted-foreground": status === "pending",
          "font-medium": status === "running",
        })}
      >
        {stepTitle}
      </span>
      {tools && tools.length > 0 && (
        <div className="flex flex-wrap items-center gap-1 sm:gap-2 w-full sm:w-auto ps-7 sm:ps-0">
          {tools.map((tool, index) => {
            const Icon = TOOL_ICONS[tool] || Wrench;
            return (
              <div
                key={index}
                className="flex items-center gap-1 text-[10px] sm:text-xs text-muted-foreground bg-muted px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full"
              >
                <Icon className="w-3 h-3 shrink-0" />
                <span className="truncate max-w-[100px] sm:max-w-none">{tool}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
